import React from 'react'
import styled from 'styled-components'

// Styles
import { defaultColor } from '../../styles/colors'
import tagBaseStyle from './TagBase'
import { applyTextStyle } from '../../styles/typography'
import { fastTransition } from '../../styles/effects'

// Types
import { AnyColor } from '../../common/models/colors'

interface IProps {
  caption: string | React.ReactNode
  captionColor?: AnyColor | string
  color?: AnyColor
  notification?: boolean
  className?: string
}

const StatusTag = (props: IProps) => {
  const color = props.color ? props.color : defaultColor
  return (
    <StyledStatusTag
      className={props.className}
      color={color}
      captionColor={props.captionColor || 'lightest'}
      notification={props.notification}
    >
      {props.caption}
    </StyledStatusTag>
  )
}

export const StyledStatusTag = styled.strong<{
  color: AnyColor
  captionColor: string
  notification?: boolean
}>`
  ${tagBaseStyle};
  display: inline-flex;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${({ theme, color }) => theme.colors[color || 'primary']};
  color: ${({ theme, captionColor }) =>
    captionColor.includes('hsl') ? captionColor : theme.colors[captionColor]};
  transition: background-color ${fastTransition};
  text-transform: capitalize;
  ${applyTextStyle('labelHeavy')}

  ${({ notification, theme }) =>
    notification &&
    `
    &:before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${theme.colors.secondary};
      margin-right: 4px;
      align-self: center;
    }
  `}
`

export default StatusTag
